const ALLOWED_VALUES = [3, 7, 11, 22, 30, 50, 150, 300];

export const marks = ALLOWED_VALUES.map((value, index) => ({
    value: index,
    label: value === 300 ? '300+' : value.toString(),
}));

export const indexToValue = (index: number) => ALLOWED_VALUES[index];
export const valueToIndex = (value: number) => ALLOWED_VALUES.indexOf(value);

export const DEFAULT_MAX_POWER = 300;
export const DEFAULT_MIN_POWER = 3;

export const DEFAULT_MIN_INDEX = valueToIndex(DEFAULT_MIN_POWER);
export const DEFAULT_MAX_INDEX = valueToIndex(DEFAULT_MAX_POWER);
export const DEFAULT_INDEX_RANGE = [DEFAULT_MIN_INDEX, DEFAULT_MAX_INDEX];

export const DEFAULT_POWER_VALUE = [DEFAULT_MIN_POWER, DEFAULT_MAX_POWER];

interface ValidatePower {
    maxPower?: number | null | undefined;
    minPower?: number | null | undefined;
}

export const validatePower = ({
    maxPower,
    minPower,
}: ValidatePower): { maxPower: number; minPower: number } | undefined => {
    if (!maxPower && !minPower) {
        return undefined;
    }

    if (maxPower && !minPower) {
        if (typeof maxPower !== 'number' || isNaN(maxPower) || maxPower < 0) {
            return undefined;
        }

        if (!ALLOWED_VALUES.includes(maxPower)) {
            return undefined;
        }

        if (maxPower === DEFAULT_MIN_POWER) {
            return undefined;
        }

        return { maxPower, minPower: DEFAULT_MIN_POWER };
    }

    if (minPower && !maxPower) {
        if (typeof minPower !== 'number' || isNaN(minPower) || minPower < 0) {
            return undefined;
        }

        if (!ALLOWED_VALUES.includes(minPower)) {
            return undefined;
        }

        if (minPower === DEFAULT_MAX_POWER) {
            return undefined;
        }

        return { maxPower: DEFAULT_MAX_POWER, minPower };
    }

    if (
        typeof maxPower !== 'number' ||
        typeof minPower !== 'number' ||
        isNaN(maxPower) ||
        isNaN(minPower)
    ) {
        return undefined;
    }

    if (maxPower < 0 || minPower < 0) {
        return undefined;
    }

    if (maxPower <= minPower) {
        return undefined;
    }

    if (!ALLOWED_VALUES.includes(maxPower) || !ALLOWED_VALUES.includes(minPower)) {
        return undefined;
    }

    return { maxPower, minPower };
};
